/* unplugin-vue-components disabled */import script from "./user-bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./user-bar.vue?vue&type=script&setup=true&lang=ts"

import "./user-bar.vue?vue&type=style&index=0&id=cca79778&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cca79778"]])

export default __exports__